import {NavComponent} from '../../components/navbar/nav.component';
import {Jivoloader} from '../../components/jivosite/jivoloader';
import {CustomSelect} from '../../components/custom-select/custom-select';
import {FaqPage} from './faq-page';

{
    const faqPage = new FaqPage(
        new NavComponent(),
        new Jivoloader(),
        new CustomSelect(),
    );
    faqPage.init();
}
